import styled from 'styled-components'
import AppLink from 'Components/AppLink'
import ImagePlaceholder from 'Components/ImagePlaceholder'

import {
  GREY_BACKGROUND, CLICKABLE_COLOR, TEXT_GREY,
  OUTLINE_COLOR, SECONDARY_NORMAL_COLOR,
} from '@CSSVars/colors'


export const _ListingCard = styled.div`
  margin: 0 6px;
  /*height: 245px;*/
  width: 225px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${GREY_BACKGROUND};
  border-radius: 10px;
`

export const _InnerCard = styled.div`
  position: relative;
  width: 100%;
  max-height: 245px;
  padding: 16px;
  border: 1px solid ${OUTLINE_COLOR};
  border-radius: 10px;
`

export const _RemoveCta = styled.button`
  height: 22px;
  width: 22px;
  padding: 0;
  background-color: white;
  position: absolute;
  top: -8px;
  right: -6px;
  border: 1px solid ${OUTLINE_COLOR};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const _ImageHolder = styled.div`
  position: relative;
  width: 100%;
  height: 145px;
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ hasHandler }) => (hasHandler ? 'cursor:pointer;' : '')}
  @media screen and (max-width: 414px) {
    height: 155px;
    max-width: calc(100vw - 100px);
  }
`

export const _ImagePlaceholder = styled(ImagePlaceholder)`
  height: 100%;
  div {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /*height: auto;*/
  }
`

export const _LockedOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  color: white;
  background-color: ${SECONDARY_NORMAL_COLOR};
  opacity: .8;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const _ListingPrice = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 18px;
  filter: ${({ showLockedStyled }) => (showLockedStyled ? 'blur(8px)' : 'none')};
`

export const _ListingTitle = styled(AppLink)`
  font-size: 14px;
  color: ${CLICKABLE_COLOR};
  text-decoration: underline;
  font-weight: 500;
  line-height: 22px;

  display: block;
  width: 188px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const _Counter = styled.div`
  font-weight: 500;
  font-size: 18px;
  color: ${TEXT_GREY};
`

export const _FormattedPriceSpan = styled.span`
  ${({ closedPrice }) => (closedPrice ? `
  font-size: 12px;
  text-decoration: line-through;
  margin-right: 4px;
  ` : '')}
`
